export class SeverityType {
    static readonly INFORMATION = 'information';
    static readonly IMPORTANT = 'important';
    static readonly SUCCESS = 'success';
    static readonly CRITICAL = 'critical';
}
